// import { Card, CardContent, Typography, Avatar, Stack } from "@mui/material";

// const TestimonialCard = ({ initials, name, rating, review,  }) => {
//   return (
//     <Card
//       sx={{
//         boxShadow: 3,
//         width: "260px", // 300px
//         borderRadius: 3,
//       }}
//     >
//       <CardContent>
//         <Stack direction="row" alignItems="center" spacing={2}>
//           {/* <Avatar sx={{ bgcolor: "#1e90ff" }}>{initials}</Avatar> */}
//           {props?.isImg ? (
//             <img
//               src={initials}
//               style={{ height: 50, width: 50, borderRadius: 50 }}
//             />
//           ) : (
//             <Avatar sx={{ bgcolor: "#1e90ff" }}>{initials}</Avatar>
//           )}
//           <Typography
//             variant="subtitle2"
//             fontWeight="bold"
//             sx={{ fontFamily: '"Poppins", serif' }}
//           >
//             {name}
//           </Typography>
//         </Stack>

//         <Typography
//           variant="body2"
//           color="text.secondary"
//           mt={1}
//           sx={{ fontFamily: '"Poppins", serif' }}
//         >
//           {"⭐".repeat(rating)}
//         </Typography>

//         <Typography
//           variant="body2"
//           color="text.secondary"
//           mt={1}
//           sx={{ fontFamily: '"Poppins", serif' }}
//         >
//           {review}
//         </Typography>
//       </CardContent>
//     </Card>
//   );
// };

// export default TestimonialCard;
import { Card, CardContent, Typography, Avatar, Stack } from "@mui/material";

const TestimonialCard = ({ initials, name, rating, review, isImg }) => {
  return (
    <Card
      sx={{
        boxShadow: 3,
        width: "260px", // 300px
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={2}>
          {isImg ? (
            <img
              src={initials}
              alt={name}
              style={{ height: 50, width: 50, borderRadius: "50%" }}
            />
          ) : (
            <Avatar sx={{ bgcolor: "#1e90ff" }}>{initials}</Avatar>
          )}
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            sx={{ fontFamily: '"Poppins", serif' }}
          >
            {name}
          </Typography>
        </Stack>

        <Typography
          variant="body2"
          color="text.secondary"
          mt={1}
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          {"⭐".repeat(rating)}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          mt={1}
          sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
        >
          {review}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
